import { useEffect, useState } from 'react';

export const useScrollPosition = () => {
  const [scrollPosition, setScrollPosition] = useState(0);

  useEffect(() => {
    const updatePosition = (e: Event) => {
      setScrollPosition(
        document.body.scrollTop ||
          document.documentElement.scrollTop ||
          window.pageYOffset ||
          window.scrollY
      );
    };

    window.addEventListener('scroll', updatePosition, true);

    return () => window.removeEventListener('scroll', updatePosition);
  }, []);

  return scrollPosition;
};
